module.exports = __webpack_public_path__ + "static/media/download-outline.d3501eb7.svg";